export const DELIVERY_TYPE = {
    DIGITAL: 'd',
    LANDLORD: 'l',
    CURRENT_ADDRESS: 'c',
    NEW_PROPERTY: 'f',
};

export const VONOVIA_BLOCKED_EMAILS = ['service@vonovia.de', 'info@vonovia.de'];

export const isVonoviaBlockedEmail = (email) =>
    !!email && VONOVIA_BLOCKED_EMAILS.includes(email.trim().toLowerCase());

// Blockierender Fehler (rot) – Vonovia-Email + digitaler Versand gewählt
export const VONOVIA_BLOCKED_EMAIL_ERROR =
    'Diese E-Mail-Adresse empfängt keine E-Mails. Für den digitalen Versand benötigen ' +
    'wir eine direkte Mitarbeiter-E-Mail-Adresse von Vonovia. Alternativ sollten Sie den ' +
    'postalischen Versandweg wählen und die Bürgschaft persönlich an die Vonovia übergeben.';
